import BlazeSlider from "blaze-slider";
import {onFind} from "@elements/init-modules-in-scope";

const defaultSelectors = {
    base: '.js-icon-teaser-slider'
};

export function init(options = {}, selectors = defaultSelectors) {
    onFind(selectors.base, function (baseElement) {
        new BlazeSlider(baseElement, {
            all: {
                slidesToScroll: 1,
                slidesToShow: 4,
                slideGap: '40px',
                draggable: true,
                loop: false
            },
            '(max-width: 767px)': {
                slidesToShow: 1,
                draggable: true,
                slideGap: '40px'
            }
        });
    });
}
